import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../Pricing.css';
import UserStatus from './UserStatus';
import API from '../api';

function Contact() {
  const [values, setValues] = useState({
    user_id: '',
    name: '',
    email: '',
    phone: '',
    feedback: ''
  });

  const [message, setMessage] = useState('');

  useEffect(() => {
    document.title = "FAQ | TradeBarta.com";
  }, []);
  

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/contact_us`, values);
      setMessage(res.data.message || 'Feedback sent!');
      setValues({ user_id: '', name: '', email: '', phone: '', feedback: '' }); // Clear form
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.message || 'Feedback submission failed');
    }
  };

  return (
    <div className="page-container">
      <div className="content-wrap">
      {/* Navbar */}
      <section className="navbar-area navbar-one">
        <div className="container">
          <nav className="navbar navbar-expand-lg">
            <a className="navbar-brand" href="/">
              <img width="200" height="70" src={require("../images/logo.png")} alt="Logo" />
            </a>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarOne">
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse sub-menu-bar" id="navbarOne">
              <ul className="navbar-nav m-auto">
                <li className="nav-item">
                  <a className="page-scroll" href="/">Home</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/pricing">Pricing</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/referral">Refer and Win</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/faq">FAQ</a>
                </li>
                <li className="nav-item">
                  <a className="active page-scroll" href="/contact">Contact Us</a>
                </li>
              </ul>
            </div>

            <div className="navbar-btn">
              <UserStatus />
            </div>
          </nav>
        </div>
      </section>

      {/* Feedback Form */}
      <section className="py-5" style={{ backgroundColor: '#f9f9f9ff' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6">
              <h1 style={{marginTop: '120px', textAlign: 'center'}}>Send Us Your Feedback</h1>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Name"
                    value={values.name}
                    required
                    onChange={(e) => setValues({ ...values, user_id: 0, name: e.target.value })}
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Email"
                    value={values.email}
                    required
                    onChange={(e) => setValues({ ...values, email: e.target.value })}
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="text"
                    name="phone"
                    className="form-control"
                    placeholder="Phone"
                    value={values.phone}
                    required
                    onChange={(e) => setValues({ ...values, phone: e.target.value })}
                  />
                </div>
                <div className="mb-3">
                  <textarea
                    name="feedback"
                    rows="5"
                    className="form-control"
                    placeholder="Type your message here..."
                    value={values.feedback}
                    required
                    onChange={(e) => setValues({ ...values, feedback: e.target.value })}
                  />
                </div>
                  <button type="submit" className="response-button">Submit</button>
                {message && (
                  <p className="mt-3 text-center" style={{ color: 'green' }}>{message}</p>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>
</div>
<section className="footer-area footer-five">
  <div className="container">
    <div className="footer-top-content">
      
      {/* Links Section */}
      <div className="footer-links">
        <ul>
          <li>
            <a href="/terms" target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </a>
          </li>
          <li>
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </li>
        </ul>
      </div>

      {/* Contact Section */}
      <div className="footer-contact">
        <h4>Contact Us:</h4>
        <a href="mailto:support@tradebarta.com">support@tradebarta.com</a>
      </div>

    </div>
  </div>

  {/* Bottom copyright section */}
  <div className="footer-copyright">
    <div className="container">
      <p className="text-center">Copyright © 2025. All Rights Reserved</p>
    </div>
  </div>
</section>

    </div>
  );
}

export default Contact;
